var Template3 = Template3 || {};

(function (window, $, Argument, app) {
    var parseFloat = window.parseFloat;

    app.supports = function (feature) {
        return window.Modernizr[feature];
    };

    app.rejects = function (feature) {
        return ! window.Modernizr[feature];
    };

    app.exec = function (name) {
        app.ActionResolver.exec.apply(app.ActionResolver, arguments);
    };

    app.registerAction = function (name, action) {
        app.ActionResolver.registerAction(name, action);
    };

    app.bind = function () {
        app.$doc.ready(function () {
            var Modernizr = window.Modernizr;

            // Throw Modernizr console warnings
            for (var prop in Modernizr) {
                if (Modernizr.hasOwnProperty(prop)) {
                    if (Modernizr[prop] === false) {
                        window.console.warn('Your browser does not support "' + prop + '", please consider upgrading to a modern browser like Google Chrome <https://www.google.com/chrome/>');
                    }
                }
            }

            // No flexbox? JS to the rescue!
            if (app.rejects('flexbox')) {
                $.getScript('https://cdnjs.cloudflare.com/ajax/libs/jquery.matchHeight/0.7.0/jquery.matchHeight-min.js', function () {
                    // Eq height will persist when cols collapse but the workaround for that is just too much of a bother.
                    // Don't resize your window when you have a shitty browser people!
                    $('.row[class*=-eq-height] > [class*="col-"]').matchHeight();
                });
            }

            /**
             * Scroll to current section
             */
            var scrollToCurrent = function (setMenuItem) {
                Argument.get(setMenuItem, false);

                if (window.location.hash && window.location.hash.match(/^#\//)) {
                    var section = window.location.hash.replace(/^#\//, '');

                    app.Scroll.section(section, false);

                    if (setMenuItem) {
                        var $item = $('.nav\\/item').has('[href^="' + window.location.pathname + window.location.hash + '"]');

                        if ($item.length) {
                            $('.nav\\/item').removeClass('--active');
                            $item.addClass('--active');
                        }
                    }
                }
            };

            scrollToCurrent(true);

            if (window.history) {
                $(window).on('popstate', function (e) {
                    if ('scrollRestoration' in window.history) {
                        window.history.scrollRestoration = 'manual';
                    }

                    e.preventDefault();
                    scrollToCurrent();

                    if (! window.location.hash) {
                        app.Scroll.section('first', false);
                    }
                });
            } else {
                $(window).hashchange(scrollToCurrent);
            }

            /**
             * Highlight nav items when section in view
             */
            app.Scroll.spy($(window), '.section', {
                offset: function () {
                    var $nav = $('#main-nav');
                    var $admin = $('#wpadminbar');

                    return $nav.height() + ($admin.length ? $admin.height() : 0) + parseFloat($('.section').css('padding-bottom'));
                },
                onChange: function (items) {
                    var $nav = $('#main-nav');

                    var inview = items.filter(function (item) {
                        return item.state === 'inViewport';
                    });

                    var $activeSection = $(inview).map(function () {
                        return this.$el.get(0);
                    }).filter(':first');

                    var section = $activeSection.attr('id').replace('section-', '');

                    $nav.find('.nav\\/item').removeClass('--active');
                    $nav.find('[data-value="' + section + '"]').parent().addClass('--active');
                }
            });

            /**
             * Close nav menu when item clicked (mobile)
             */
            $('#main-nav').on('click', '.nav\\/item', function () {
                if ($(window).width() < app.NAV_BREAKPOINT) {
                    app.exec('Nav.close', 'main-nav');
                }
            });
        });
    };
})(window, jQuery, Argument, Template3);
